import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../Models/grid';
import {Product} from '../../../back-office/Models/Product';
import {ActionColumn, ActionItem, TextColumn} from '../../Models/columns';

@Component({
  selector: 'app-grid-component',
  templateUrl: './grid-component.component.html',
  styleUrls: ['./grid-component.component.scss']
})
export class GridComponentComponent implements OnInit {
  @ViewChild('productsModal', {static: false}) productsModal = null;
  productsGrid: Grid;
  constructor() { }

  ngOnInit() {
  }

}
